import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { eventDeleteRequest, fetchEventsRequest } from '../../../actions/index.js';
import { AUTH_CAPS, EVENT_DATA, EVENT_DATA_EVENTS, EVENT_DATA_SETTINGS } from '../../../constants/state.js';
// import toJS from '../../../containers/general/toJS.js';
import getData from '../../../functions/getData.js';
import SortableEventsListContainer from './SortableEventsListContainer.jsx';
import hasCap from '../../../functions/hasCap.js';
import { DELETE_EVENT_CAP, GET_EVENT_CAP } from '../../../constants/caps.js';
import { compose } from 'redux';
import toJS from '../../../hoc/toJS.jsx';

const mapStateToProps = state => ({
    eventsData: getData(state, EVENT_DATA_EVENTS),
    eventsStatus: getData(state, [EVENT_DATA, 'events', 'status']),
    eventsError: getData(state, [EVENT_DATA, 'events', 'error']),
    settingsStatus: getData(state, [EVENT_DATA, 'settings', 'status']),
    settingsError: getData(state, [EVENT_DATA, 'settings', 'status']),
    settingsData: getData(state, [EVENT_DATA_SETTINGS]),
    caps: getData(state, AUTH_CAPS)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    onFetchEvents: ()  => {
        if(hasCap(ownProps.caps, GET_EVENT_CAP)) {
            dispatch(fetchEventsRequest())
        }
        
    },
    onDeleteEvent: id => {
        if(hasCap(ownProps.caps, DELETE_EVENT_CAP)) {
            dispatch(eventDeleteRequest(id))
        }
    }
})

const PageEvents = ({eventsData, eventsStatus, eventsError, settingsData, settingsStatus, settingsError, caps, onFetchEvents, onDeleteEvent}) => {
    const [displayOverlay, setDisplayOverlay] = useState(true)

    useEffect(() => {
        if(!displayOverlay) {
            setDisplayOverlay(true)
        }
    },[eventsStatus, settingsStatus])

    const canDeleteEvent = hasCap(caps, DELETE_EVENT_CAP)


    return <SortableEventsListContainer
        eventsData={eventsData}
        eventsStatus={eventsStatus}
        eventsError={eventsError}
        settingsData={settingsData}
        settingsStatus={settingsStatus}
        settingsError={settingsError}
        displayOverlay={displayOverlay}
        setDisplayOverlay={setDisplayOverlay}
        canDeleteEvent={canDeleteEvent}
        onFetchEvents={onFetchEvents}
        onDeleteEvent={onDeleteEvent}
    />
}

export default compose(
    connect(mapStateToProps, null),
    toJS(),
    connect(null, mapDispatchToProps)
)(PageEvents)